
import { defineComponent, ref } from 'vue';
import RacingLeaderboard from './RacingLeaderboard.vue';
import BreedingLeaderboard from './BreedingLeaderboard.vue';

export default defineComponent({
  name: 'Leaderboards',
  components: { RacingLeaderboard, BreedingLeaderboard }
});
